import { render, staticRenderFns } from "./setting-audience.vue?vue&type=template&id=91993c74&"
import script from "./setting-audience.vue?vue&type=script&lang=js&"
export * from "./setting-audience.vue?vue&type=script&lang=js&"
import style0 from "./setting-audience.vue?vue&type=style&index=0&id=91993c74&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports